webpackJsonp([7054999383399],{

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Prismic = __webpack_require__(36);
	
	var query = exports.query = "** extracted graphql fragment **";
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Campaigns = function (_React$Component) {
	  _inherits(Campaigns, _React$Component);
	
	  function Campaigns(props) {
	    _classCallCheck(this, Campaigns);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.changeRegion = function (event) {
	      _this.setState({ region: event.target.value }, function () {
	        _this.getCampaigns();
	      });
	    };
	
	    _this.changeStatus = function (event) {
	      _this.setState({ status: event.target.value }, function () {
	        _this.getCampaigns();
	      });
	    };
	
	    _this.changeInstitution = function (event) {
	      _this.setState({ institution: event.target.value }, function () {
	        _this.getCampaigns();
	      });
	    };
	
	    _this.getCampaigns = function () {
	      var predicates = [Prismic.Predicates.at("document.type", "projec")];
	      if (_this.state.region !== "") {
	        predicates.push(Prismic.Predicates.at("my.projec.region", _this.state.region));
	      }
	      if (_this.state.status !== "") {
	        predicates.push(Prismic.Predicates.at("my.projec.status", _this.state.status));
	      }
	      if (_this.state.institution !== "") {
	        predicates.push(Prismic.Predicates.at("my.resource.institution", _this.state.institution));
	      }
	      Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2").then(function (api) {
	        return api.query(predicates, {
	          lang: _this.props.data.page.lang,
	          fetchLinks: "region.uid"
	        });
	      }).then(function (response) {
	        _this.setState({ campaigns: response.results });
	      });
	    };
	
	    _this.state = {
	      campaigns: [],
	      region: "",
	      status: "",
	      institution: ""
	    };
	    return _this;
	  }
	
	  Campaigns.prototype.componentDidMount = function componentDidMount() {
	    this.context.setAltLanguages(undefined);
	    this.getCampaigns();
	  };
	
	  Campaigns.prototype.render = function render() {
	    var json = undefined;
	    if (this.props.data.page.raw) {
	      json = JSON.parse(this.props.data.page.raw);
	    }
	    if (this.props.data.campaigns) {
	      this.props.data.campaigns.edges.sort(function (a, b) {
	        if (a.node.uid < b.node.uid) return -1;
	        if (a.node.uid > b.node.uid) return 1;
	        return 0;
	      });
	    }
	    return _react2.default.createElement(
	      "div",
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      json && _react2.default.createElement(_components.Head, { source: json.data }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        json && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _components.PageHeader,
	            { title: json.data.title[0].text, color: json.uid },
	            json.data.subtitle[0] && _react2.default.createElement(_components.H2, { children: json.data.subtitle[0].text, fontSize: [4, 5] }),
	            json.data.description[0] && _react2.default.createElement(_components.Text, { children: json.data.description[0].text })
	          ),
	          json.data.body && _react2.default.createElement(
	            _components.PageSection,
	            null,
	            json.data.body1[0] && _react2.default.createElement(
	              _components.PageSidebar,
	              null,
	              json.data.body1.map(function (callout, index) {
	                return _react2.default.createElement(_components.CalloutCard, {
	                  key: "callout" + index,
	                  callout: callout.primary,
	                  lang: json.lang
	                });
	              })
	            ),
	            _react2.default.createElement(
	              _components.PageContent,
	              null,
	              _react2.default.createElement(
	                _rebass.Box,
	                { mb: 6 },
	                _react2.default.createElement(_components.Article, {
	                  dangerouslySetInnerHTML: {
	                    __html: _prismicDom.RichText.asHtml(json.data.body, linkResolver)
	                  }
	                })
	              ),
	              this.props.data.campaigns && _react2.default.createElement(
	                _rebass.Box,
	                null,
	                this.props.data.campaigns.edges.map(function (campaign, index) {
	                  return _react2.default.createElement(_components.CampaignCard, {
	                    key: "campaign" + index,
	                    object: campaign.node
	                  });
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Campaigns;
	}(_react2.default.Component);
	
	Campaigns.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Campaigns;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-campaigns-js-db1c94b9706bdb19a1d6.js